import {axios} from "~/plugins/axios";

const getDefaultState_AudioPlayer = () => {
  return {
    playlist: [],
    isPlaying: false,
    currentAudio: null,
    durationSeconds: 0,
    currentSeconds: 0,
  }
}
const state = getDefaultState_AudioPlayer();

const getters = {
  playlist: state => state.playlist,
  isPlaying: state => state.isPlaying,
  currentAudio: state => state.currentAudio,
  durationSeconds: state => state.durationSeconds,
  currentSeconds: state => state.currentSeconds,
  formatTime() {
    return secs => {
      let minutes = Math.floor(secs / 60) || 0;
      let seconds = Math.floor(secs - minutes * 60) || 0;
      if (seconds < 10) seconds = `0${seconds}`;

      return `${minutes}:${seconds}`
    }
  }
}

const actions = {
  async initPlaylist({commit}, urls) {
    commit('shared/SET_LOADING', true, {root: true});

    let playlist = [];

    for (let index in urls) {
      const url = urls[index];

      await axios.get(url)
        .then((response) => {
          let data = response.data;
          const BASE64_MARKER = ';base64,';
          const base64Index = data.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
          const base64 = data.substring(base64Index);
          const raw = window.atob(base64);
          const rawLength = raw.length;
          const array = new Uint8Array(new ArrayBuffer(rawLength));

          for (let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
          }

          const blob = new Blob([array], {type: 'audio/mpeg'});
          const blobUrl = URL.createObjectURL(blob);
          playlist.push(blobUrl);
          commit('SET_PLAYLIST', playlist);

        }).catch(err => {
          if (err.data !== undefined) {
            commit('shared/SET_ERROR', err.data, {root: true});
          }

          console.error(err);
          // throw err;
        });

      commit('shared/SET_LOADING', false, {root: true});
    }
  },

  changeIsPlaying({state, commit}, value = null) {
    value = value === null ? !state.isPlaying : value
    commit('SET_IS_PLAYING', value);
  },

  updateTimer({state, commit}) {
    commit('SET_CURRENT_SECONDS', parseInt(state.currentAudio.currentTime));
  },
  changeCurrentAudio({commit}, currentAudio) {
    commit('SET_CURRENT_AUDIO', currentAudio);
  },
  changeCurrentSeconds({state, commit}, seconds) {
    commit('SET_CURRENT_SECONDS', parseInt(seconds));
    state.currentAudio.play();
    commit('SET_IS_PLAYING', true);
  },

  async clearPlayer({commit}) {
    commit('SET_IS_PLAYING', false);
    commit('SET_CURRENT_AUDIO', null);
    commit('SET_CURRENT_SECONDS', 0);
    commit('SET_PLAYLIST', []);
  },
}

const mutations = {
  SET_PLAYLIST(state, data) {
    state.playlist = data;
  },

  // SET_CURRENT_AUDIO(state, url) {
  //
  // },
  SET_IS_PLAYING(state, value) {
    state.isPlaying = value;
  },

  SET_CURRENT_AUDIO(state, value) {
    state.currentAudio = value;
  },

  SET_CURRENT_SECONDS(state, value) {
    state.currentSeconds = value;
  },


  RESET_STATE_AUDIOPLAYER (state) {
    Object.assign(state, getDefaultState_AudioPlayer())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
